import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  getCategories,
  getError,
  getIsLoading,
} from 'store/selectors/categories';
import {
  addCategory,
  editCategory,
  deleteCategory,
} from 'store/actions/categories';
import Categories from './Categories';

const selector = createStructuredSelector({
  isLoading: getIsLoading,
  error: getError,
  categories: getCategories,
});

const actions = {
  onAddCategory: addCategory,
  onEditCategory: editCategory,
  onDeleteCategory: deleteCategory,
};

export default connect(
  selector,
  actions,
)(Categories);
